import { useState, useEffect } from 'react'
import RealEstatePageLayout from '../components/partials/RealEstatePageLayout'
import Link from 'next/link'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import ProgressBar from 'react-bootstrap/ProgressBar'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import ToggleButton from 'react-bootstrap/ToggleButton'
import Form from 'react-bootstrap/Form'
import ScrollLink from '../components/ScrollLink'
import { FilePond, registerPlugin } from 'react-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageCrop from 'filepond-plugin-image-crop'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'
import { PatternFormat } from 'react-number-format'
import * as yup from 'yup';
import { Formik, useFormik } from 'formik';
import Swal from 'sweetalert2'


import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import 'leaflet/dist/leaflet.css'
import axios from "axios";
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import PhoneInputField from '../components/PhoneInputField'
import { useTranslation } from "react-i18next";

const validationSchema = yup.object({
  first_name: yup.string().required("le prénom est obligatoire"),
  last_name: yup.string().required("le nom est obligatoire"),
  email: yup.string().email("l'email doit être valide").required("l'email est obligatoire"),
  // phone_number: yup.string().required("le numéro de téléphone est obligatoire"),
  phone_number: yup.string()
    .required("le numéro de téléphone est obligatoire")
    .test('is-valid-phone', 'Numéro de téléphone invalide', function (value) {
      if (!value) return false;
      try {
        const phoneUtil = PhoneNumberUtil.getInstance();
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
  type_bien: yup.string().required("le type de bien est obligatoire"),
  adresse: yup.string().required("l'adresse est obligatoire"),
  quartier: yup.string().required("le quartier est obligatoire"),
  ville: yup.string().required("la ville est obligatoire"),
  travaux: yup.string().required("Votre bien a-t-il besoin de travaux ?"),
  surface_habitable: yup.number().required("La superficie habitable est obligatoire").moreThan(10, "la superficie habitable doit être supérieure à 10m2"),
  // email: yup
  //     .string('Enter your email')
  //     .email('Enter a valid email')
  //     .required('Email is required'),
  // password: yup
  //     .string('Enter your password')
  //     .min(8, 'Password should be of minimum 8 characters length')
  //     .required('Password is required'),
});
const EstimatePage = () => {
  const { t } = useTranslation('common');
  const anchorStatic = [
    { to: 'info-global', label: 'Infos globales', completed: false },
    { to: 'location', label: 'Localisation', completed: false },
    { to: 'details', label: 'Bien à estimer', completed: false },
    // {to: 'building', label: 'Caractéristiques Immeuble', completed: false},
    // {to: 'project', label: 'Votre projet', completed: false},
    { to: 'contacts', label: 'Contact', completed: false }
  ];
  // Anchor lnks
  const [anchors, setAnchors] = useState(anchorStatic);
  const [isPhoneValid, setIsPhoneValid] = useState(false);

  // Number of bedrooms radios buttons
  const [bedroomsValue, setBedroomsValue] = useState('4')
  const bedrooms = [
    { name: '1', value: '1' },
    { name: '2', value: '2' },
    { name: '3', value: '3' },
    { name: '4', value: '4' },
    { name: '5', value: '5' },
    { name: '6', value: '6' },
    { name: '7+', value: '7+' }
  ]

  // Number of bathrooms radios buttons
  const [bathroomsValue, setBathroomsValue] = useState('2')
  const bathrooms = [
    { name: '1', value: '1' },
    { name: '2', value: '2' },
    { name: '3', value: '3' },
    { name: '4', value: '4' },
    { name: '5+', value: '5+' }
  ]

  // Number of parking radios buttons
  const [parkingsValue, setParkingsValue] = useState('2')
  const parkings = [
    { name: '1', value: '1' },
    { name: '2', value: '2' },
    { name: '3', value: '3' },
    { name: '4', value: '4' },
    { name: '5+', value: '5+' }
  ]

  // Number of floor radios buttons
  const [floorsValue, setFloorsValue] = useState('2')
  const floors = [
    { name: '1', value: '1' },
    { name: '2', value: '2' },
    { name: '3', value: '3' },
    { name: '4', value: '4' },
    { name: '5+', value: '5+' }
  ]


  // Register Filepond plugins
  registerPlugin(
    FilePondPluginFileValidateType,
    FilePondPluginFileValidateSize,
    FilePondPluginImagePreview,
    FilePondPluginImageCrop,
    FilePondPluginImageResize,
    FilePondPluginImageTransform
  )

  const formik = useFormik({
    initialValues: {
      type_bien: '',
      quartier: '',
      ville: '',
      adresse: '',
      surface_habitable: '',
      nbr_chambres: 1,
      nbr_bains: '',
      nbr_parking: '',
      etage_bien: '',
      nbr_terrasse_balcon: '',
      travaux: false,
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
    },
    validationSchema,
    validateOnMount: false,
    onSubmit: values => {
      const formData = new FormData();
      Object.keys(values).map(key => {
        formData.append(key, values[key]);
      });

      axios.post(`${process.env.NEXT_PUBLIC_API_URL}/api/ads/leads/estimation`, formData).then(function (response) {
        console.log(response);
        formik.resetForm();
        deactivateAnchor('info-global')
        deactivateAnchor('location')
        deactivateAnchor('details')
        deactivateAnchor('contacts')
        setPercentageProgress([]);
        Swal.fire({
          text: "L'équipe Facilykey vous contactera après avoir examiné votre formulaire",
          icon: "success",
          buttonsStyling: !1,
          confirmButtonText: "Ok, Merci!",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        });
      })
        .catch(function (error) {
          console.error(error);
        });
    },
  });
  const [percentageProgress, setPercentageProgress] = useState([]);

  const [cities, setCities] = useState([]);
  const [neighbourhoodsByCity, setNeighbourhoodsByCity] = useState([]);


  useEffect(() => {
    fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/ads/localisation`)
      .then(res => res.json())
      .then(res => {
        console.log(res)
        if (res?.cities) {
          setCities(res.cities);
          setNeighbourhoodsByCity(res.neighbourhoods_by_city);
        }
      });
  }, []);

  let decreaseProgress = (nameAnchor) => {
    let modifiedPercentageProgress = percentageProgress;
    let index = modifiedPercentageProgress.indexOf(nameAnchor);
    if (index !== -1) {
      modifiedPercentageProgress.splice(index, 1);
    }
  }
  let increaseProgress = (nameAnchor) => {
    if (!percentageProgress.includes(nameAnchor)) {
      let modifiedPercentageProgress = percentageProgress;
      modifiedPercentageProgress.push(nameAnchor);
      modifiedPercentageProgress = [...new Set(modifiedPercentageProgress)]; // to keep the array unique
      setPercentageProgress(modifiedPercentageProgress)
    }
  }
  let activateAnchor = (nameAnchor) => {
    let modifiedAnchors = anchors;
    let idx = modifiedAnchors.findIndex((item) => item.to === nameAnchor);
    if (modifiedAnchors[idx]) {
      modifiedAnchors[idx].completed = true;
      setAnchors(modifiedAnchors);
      increaseProgress(nameAnchor);
    }
  }

  let deactivateAnchor = (nameAnchor) => {
    // console.log('called deactivating : '+ nameAnchor);
    let modifiedAnchors = anchors;
    let idx = modifiedAnchors.findIndex((item) => item.to === nameAnchor);
    if (modifiedAnchors[idx]) {
      modifiedAnchors[idx].completed = false;
      setAnchors(modifiedAnchors);
      decreaseProgress(nameAnchor);
    }
  }

  useEffect(() => {
    // const validatePhone = (phone) => {
    //   try {
    //     const phoneUtil = PhoneNumberUtil.getInstance();
    //     return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    //   } catch (error) {
    //     return false;
    //   }
    // };

    // if (formik.values.phone_number) {
    //   const valid = validatePhone(formik.values.phone_number);
    //   setIsPhoneValid(valid);
    // } else {
    //   setIsPhoneValid(false);
    // }
    // console.log(formik.valu.phone_number)
  }, [formik.values.phone_number]);


  useEffect(() => {
    if (formik.values.type_bien.length > 0) {
      activateAnchor('info-global');
    } else {
      deactivateAnchor('info-global');
    }
  }, [formik.values.type_bien]);

  useEffect(() => {
    if (formik.values.travaux && formik.values.surface_habitable.toString().length > 0) {
      activateAnchor('details');
    } else {
      deactivateAnchor('details');
    }
  }, [formik.values.travaux, formik.values.surface_habitable]);

  useEffect(() => {
    let { quartier, ville, adresse } = formik.values;
    console.log(quartier.length > 0)
    if (quartier.length > 0 && ville.length > 0 && adresse.length > 0) {
      activateAnchor('location');
    } else {
      deactivateAnchor('location');
    }
  }, [formik.values.quartier, formik.values.ville, formik.values.adresse]);

  useEffect(() => {
    let { first_name, last_name, email, phone_number } = formik.values;
    if (first_name.length > 0 && last_name.length > 0 && email.length > 0 && phone_number.length > 0) {
      activateAnchor('contacts');
    } else {
      deactivateAnchor('contacts');
    }
  }, [formik.values.first_name, formik.values.last_name, formik.values.email, formik.values.phone_number]);

  // useEffect(() => {
  //   if (formik.values.type_bien.length > 0) {
  //     setPercentageProgress(10);
  //     setAnchors([
  //       {to: 'info-global', label: 'Infos globales', completed: true},
  //       {to: 'location', label: 'Localisation', completed: false},
  //       {to: 'details', label: 'Bien à estimer', completed: false},
  //       {to: 'building', label: 'Caractéristiques Immeuble', completed: false},
  //       // {to: 'project', label: 'Votre projet', completed: false},
  //       {to: 'contacts', label: 'Contact', completed: false}
  //     ]);
  //   }
  // }, [formik.values]);


  return (
    <RealEstatePageLayout
      pageTitle={t("Estimer son bien")}
      description={t("Estimez gratuitement votre appartement, villa ou terrain au Maroc en 2 minutes. Un conseiller Facilykey affine ensuite l'avis de valeur sur place.")}
      activeNav='Pages'
    >

      {/* Page container */}
      <Container className='mt-5 mb-md-4 py-5'>
        <Row>

          {/* Page content */}
          <Col lg={8}>

            {/* Breadcrumbs */}
            <Breadcrumb className='mb-3 pt-md-3'>
              <Breadcrumb.Item linkAs={Link} href='/'>{t("Accueil")}</Breadcrumb.Item>
              <Breadcrumb.Item active>{t("Estimer")}</Breadcrumb.Item>
            </Breadcrumb>

            {/* Title */}
            <div className='mb-4'>
              <h1 className='h2 mb-0'>{t("Estimation gratuite de votre bien")}</h1>
              <div className='d-lg-none pt-3 mb-2'>{percentageProgress.length * 100 / anchors.length}% {t("de contenu rempli")}</div>
              <ProgressBar variant='accent' now={percentageProgress.length * 100 / anchors.length} style={{ height: '.25rem' }} className='d-lg-none mb-4' />
            </div>
            <form onSubmit={formik.handleSubmit}>
              <section id='info-global' className='card card-body border-0 shadow-sm p-4 mb-4'>
                <h2 className='h4 mb-4'>
                  <i className='fi-building text-primary fs-5 mt-n1 me-2'></i>
                  {t("Informations générales")}
                </h2>
                <Row>
                  <Form.Group as={Col} controlId='ab-property-type' className='mb-3'>
                    <Form.Label>{t("Type de bien")} <span className='text-danger'>*</span></Form.Label>
                    <Form.Select
                      required
                      onChange={formik.handleChange('type_bien')}
                      onBlur={formik.handleBlur('type_bien')}
                      isValid={formik.touched.type_bien && !Boolean(formik.errors.type_bien)}
                      isInvalid={formik.touched.type_bien && Boolean(formik.errors.type_bien)}
                      value={formik.values.type_bien}
                    >
                      <option value='' disabled>{t("Choisissez le type de bien")}</option>
                      <option value='appartement'>{t("Appartement")}</option>
                      <option value='maison'>{t("Maison")}</option>
                      <option value='villa'>{t("Villa")}</option>
                      <option value='commercial'>{t("Commercial")}</option>
                      <option value='terrain'>{t("Terrain")}</option>
                      <option value='immeuble'>{t("Immeuble")}</option>
                    </Form.Select>
                    {formik.errors.type_bien && formik.touched.type_bien ? <Form.Control.Feedback type='invalid'>{t(formik.errors.type_bien)}</Form.Control.Feedback> : null}
                  </Form.Group>
                </Row>
              </section>

              <section id='location' className='card card-body border-0 shadow-sm p-4 mb-4'>
                <h2 className='h4 mb-4'>
                  <i className='fi-map-pin text-primary fs-5 mt-n1 me-2'></i>
                  {t("Localisation")}
                </h2>
                <Row>
                  <Form.Group as={Col} sm={6} controlId='ap-country' className='mb-3'>
                    <Form.Label>{t('Ville')} <span className='text-danger'>*</span></Form.Label>
                    <Form.Select
                      onChange={formik.handleChange('ville')}
                      onBlur={formik.handleBlur('ville')}
                      isValid={formik.touched.ville && !Boolean(formik.errors.ville)}
                      isInvalid={formik.touched.ville && Boolean(formik.errors.ville)}
                      value={formik.values.ville}
                      required
                    >
                      <option value={''} disabled>{t("Choisissez une ville")}</option>
                      {cities.map((item, index) => <option key={index} value={item.id_city}>{item.name}</option>)}
                    </Form.Select>
                    {formik.errors.ville && formik.touched.ville ? <Form.Control.Feedback type='invalid'>{formik.errors.ville}</Form.Control.Feedback> : null}
                  </Form.Group>
                  <Form.Group as={Col} sm={6} controlId='ap-city' className='mb-3'>
                    <Form.Label>{t("Quartier")} <span className='text-danger'>*</span></Form.Label>
                    <Form.Select
                      onChange={formik.handleChange('quartier')}
                      onBlur={formik.handleBlur('quartier')}
                      isValid={formik.touched.quartier && !Boolean(formik.errors.quartier)}
                      isInvalid={formik.touched.quartier && Boolean(formik.errors.quartier)}
                      value={formik.values.quartier}
                      required
                    >
                      <option value='' disabled>{t("Choisissez un quartier")}</option>
                      {formik.values.ville > 0 && neighbourhoodsByCity[formik.values.ville].map((item, index) => <option key={index} value={item.id_neighborhood}>{item.name}</option>)}
                    </Form.Select>
                    <Form.Control.Feedback type='invalid'>{neighbourhoodsByCity.length > 0}</Form.Control.Feedback>
                    {formik.errors.quartier && formik.touched.quartier ? <Form.Control.Feedback type='invalid'>{t(formik.errors.quartier)}</Form.Control.Feedback> : null}
                  </Form.Group>
                  <Form.Group as={Col} sm={12} controlId='ap-address' className='mb-3'>
                    <Form.Label>{t("Adresse complète")} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control onChange={formik.handleChange('adresse')}
                      onBlur={formik.handleBlur('adresse')}
                      isValid={formik.touched.adresse && !Boolean(formik.errors.adresse)}
                      isInvalid={formik.touched.adresse && Boolean(formik.errors.adresse)}
                      value={formik.values.adresse}
                      required />
                    {formik.errors.adresse && formik.touched.adresse ? <Form.Control.Feedback type='invalid'>{t(formik.errors.adresse)}</Form.Control.Feedback> : null}
                  </Form.Group>
                </Row>
              </section>

              <section id='details' className='card card-body border-0 shadow-sm p-4 mb-4'>
                <h2 className='h4 mb-4'>
                  <i className='fi-edit text-primary fs-5 mt-n1 me-2'></i>
                  {t("Caractéristiques du bien")}
                </h2>
                <Form.Group controlId='ap-area' className='mb-4' style={{ maxWidth: '25rem' }}>
                  <Form.Label>{t("Superficie habitable (m2)")} <span className='text-danger'>*</span></Form.Label>
                  <Form.Control type='number'
                    min={20}
                    onChange={formik.handleChange('surface_habitable')}
                    onBlur={formik.handleBlur('surface_habitable')}
                    value={formik.values.surface_habitable}
                    isValid={formik.touched.surface_habitable && !Boolean(formik.errors.surface_habitable)}
                    isInvalid={formik.touched.surface_habitable && Boolean(formik.errors.surface_habitable)}
                    required
                  />
                  {formik.errors.surface_habitable && formik.touched.surface_habitable ? <Form.Control.Feedback type='invalid'>{t(formik.errors.surface_habitable)}</Form.Control.Feedback> : null}
                </Form.Group>
                <Form.Group className='mb-4'>
                  <Form.Label className='d-block fw-bold mb-2 pb-1'>{t("Chambres et séjours")}</Form.Label>
                  <ButtonGroup size='sm'>
                    {bedrooms.map((bedroom, indx) => (
                      <ToggleButton
                        key={indx}
                        type='radio'
                        id={`bedrooms-${indx}`}
                        name='bedrooms'
                        value={bedroom.value}
                        checked={formik.values.nbr_chambres === bedroom.value}
                        onChange={formik.handleChange('nbr_chambres')}
                        onBlur={formik.handleBlur('nbr_chambres')}
                        variant='outline-secondary fw-normal'
                      >{bedroom.name}</ToggleButton>
                    ))}
                  </ButtonGroup>
                </Form.Group>
                <Form.Group className='mb-4'>
                  <Form.Label className='d-block fw-bold mb-2 pb-1'>{t("Salles de bain")}</Form.Label>
                  <ButtonGroup size='sm'>
                    {bathrooms.map((bathroom, indx) => (
                      <ToggleButton
                        key={indx}
                        type='radio'
                        id={`bathrooms-${indx}`}
                        name='bathrooms'
                        value={bathroom.value}
                        checked={formik.values.nbr_bains === bathroom.value}
                        onChange={formik.handleChange('nbr_bains')}
                        onBlur={formik.handleBlur('nbr_bains')}
                        variant='outline-secondary fw-normal'
                      >{bathroom.name}</ToggleButton>
                    ))}
                  </ButtonGroup>
                </Form.Group>
                <Form.Group className='mb-4'>
                  <Form.Label className='d-block fw-bold mb-2 pb-1'>{t("Places de parking")}</Form.Label>
                  <ButtonGroup size='sm'>
                    {parkings.map((parking, indx) => (
                      <ToggleButton
                        key={indx}
                        type='radio'
                        id={`parkings-${indx}`}
                        name='parkings'
                        value={parking.value}
                        checked={formik.values.nbr_parking === parking.value}
                        onChange={formik.handleChange('nbr_parking')}
                        onBlur={formik.handleBlur('nbr_parking')}
                        variant='outline-secondary fw-normal'
                      >{parking.name}</ToggleButton>
                    ))}
                  </ButtonGroup>
                </Form.Group>
                <Form.Group className='mb-4'>
                  <Form.Label className='d-block fw-bold mb-2 pb-1'>{t("Etage du bien")}</Form.Label>
                  <ButtonGroup size='sm'>
                    {floors.map((floor, indx) => (
                      <ToggleButton
                        key={indx}
                        type='radio'
                        id={`floor-${indx}`}
                        name='floor'
                        value={floor.value}
                        checked={formik.values.etage_bien === floor.value}
                        onChange={formik.handleChange('etage_bien')}
                        onBlur={formik.handleBlur('etage_bien')}
                        variant='outline-secondary fw-normal'
                      >{floor.name}</ToggleButton>
                    ))}
                  </ButtonGroup>
                </Form.Group>
                <Form.Group className='mb-4'>
                  <Form.Label className='d-block fw-bold mb-2 pb-1'>{t("Terrasses et balcons")}</Form.Label>
                  <ButtonGroup size='sm'>
                    {floors.map((terrase, indx) => (
                      <ToggleButton
                        key={indx}
                        type='radio'
                        id={`terrase-${indx}`}
                        name='terrase'
                        value={terrase.value}
                        checked={formik.values.nbr_terrasse_balcon === terrase.value}
                        onChange={formik.handleChange('nbr_terrasse_balcon')}
                        onBlur={formik.handleBlur('nbr_terrasse_balcon')}
                        variant='outline-secondary fw-normal'
                      >{terrase.name}</ToggleButton>
                    ))}
                  </ButtonGroup>
                </Form.Group>
                <div className='form-label fw-bold pt-3 pb-2'>{t("Votre bien a-t-il besoin de travaux ?")} <span className='text-danger'>*</span></div>
                <Form.Check
                  type='radio'
                  name='renovation'
                  id='renovated'
                  label={t('Oui')}
                  value={'Oui'}
                  checked={formik.values.travaux === 'Oui'}
                  onBlur={formik.handleBlur('travaux')}
                  onChange={formik.handleChange('travaux')}
                />
                <Form.Check
                  type='radio'
                  name='renovation'
                  id='no-renovated'
                  label={t('Non')}
                  value={'Non'}
                  checked={formik.values.travaux === 'Non'}
                  onBlur={formik.handleBlur('travaux')}
                  onChange={formik.handleChange('travaux')}
                />
              </section>

              <section id='building' className='card card-body border-0 shadow-sm p-4 mb-4 d-none'>
                <h2 className='h4 mb-4'>
                  <i className='fi-building text-primary fs-5 mt-n1 me-2'></i>
                  {t("Caractéristiques de l'immeuble")}
                </h2>
                <Row>
                  <Form.Group as={Col} controlId='ab-property-type' className='mb-3'>
                    <Form.Label>{t("Année de construction")} <span className='text-danger'>*</span></Form.Label>
                    <Form.Select defaultValue='rent' required>
                      <option value='' disabled>{t("Choisissez l'année de construction")}</option>
                      <option value='apartment'>Avant 1900</option>
                      <option value='house'>1900 - 1950</option>
                      <option value='commercial'>1950 - 1970</option>
                      <option value='land'>1970 - 1980</option>
                      <option value='building'>1980 - 1990</option>
                      <option value='building'>1990 - 2000</option>
                      <option value='building'>2000 - 2010</option>
                      <option value='building'>Après 2010</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} controlId='ab-property-type' className='mb-3'>
                    <Form.Label>Matériau de construction principal <span className='text-danger'>*</span></Form.Label>
                    <Form.Select defaultValue='rent' required>
                      <option value='' disabled>Choisissez le matériau de construction</option>
                      <option value='apartment'>Pierre de taille</option>
                      <option value='house'>Pierre et brique</option>
                      <option value='commercial'>Brique</option>
                      <option value='land'>Béton</option>
                      <option value='building'>Parpaing</option>
                      <option value='building'>Bois</option>
                      <option value='building'>Autre</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
              </section>

              {/*<section id='project' className='card card-body border-0 shadow-sm p-4 mb-4'>*/}
              {/*  <h2 className='h4 mb-4'>*/}
              {/*    <i className='fi-file text-primary fs-5 mt-n1 me-2'></i>*/}
              {/*    Votre projet*/}
              {/*  </h2>*/}
              {/*  <div className='form-label fw-bold pt-3 pb-2'>Vous souhaitez :</div>*/}
              {/*  <Form.Check*/}
              {/*    type='radio'*/}
              {/*    name='Rent'*/}
              {/*    id='rent'*/}
              {/*    value='Oui'*/}
              {/*    label='Vendre'*/}
              {/*  />*/}
              {/*  <Form.Check*/}
              {/*    type='radio'*/}
              {/*    name='Rent'*/}
              {/*    id='rent-no'*/}
              {/*    value='Non'*/}
              {/*    label='Acheter'*/}
              {/*  />*/}
              {/*  <Form.Check*/}
              {/*    type='radio'*/}
              {/*    name='Rent'*/}
              {/*    id='rent-no'*/}
              {/*    value='Non'*/}
              {/*    label='Estimer'*/}
              {/*  />*/}
              {/*  <div className='form-label fw-bold pt-3 pb-2'>Sous quel délais ?</div>*/}
              {/*  <Form.Check*/}
              {/*    type='radio'*/}
              {/*    name='Rent'*/}
              {/*    id='rent'*/}
              {/*    value='Oui'*/}
              {/*    label='Immédiatement'*/}
              {/*  />*/}
              {/*  <Form.Check*/}
              {/*    type='radio'*/}
              {/*    name='Rent'*/}
              {/*    id='rent-no'*/}
              {/*    value='Non'*/}
              {/*    label='3 prochains mois'*/}
              {/*  />*/}
              {/*  <Form.Check*/}
              {/*    type='radio'*/}
              {/*    name='Rent'*/}
              {/*    id='rent-no'*/}
              {/*    value='Non'*/}
              {/*    label='6 prochains mois'*/}
              {/*  />*/}
              {/*</section>*/}

              <section id='contacts' className='card card-body border-0 shadow-sm p-4 mb-4'>
                <h2 className='h4 mb-4'>
                  <i className='fi-phone text-primary fs-5 mt-n1 me-2'></i>
                  {t("Fiche contact")}
                </h2>
                <Row>
                  <Form.Group as={Col} sm={6} controlId='ab-fn' className='mb-3'>
                    <Form.Label>{t('Prénom')} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control onChange={formik.handleChange('first_name')}
                      onBlur={formik.handleBlur('first_name')}
                      isValid={formik.touched.first_name && !Boolean(formik.errors.first_name)}
                      isInvalid={formik.touched.first_name && Boolean(formik.errors.first_name)}
                      value={formik.values.first_name}
                      required />
                    {formik.errors.first_name && formik.touched.first_name ? <Form.Control.Feedback type='invalid'>{formik.errors.first_name}</Form.Control.Feedback> : null}
                  </Form.Group>
                  <Form.Group as={Col} sm={6} controlId='ab-sn' className='mb-3'>
                    <Form.Label>{t('Nom de famille')} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control onChange={formik.handleChange('last_name')}
                      onBlur={formik.handleBlur('last_name')}
                      isValid={formik.touched.last_name && !Boolean(formik.errors.last_name)}
                      isInvalid={formik.touched.last_name && Boolean(formik.errors.last_name)}
                      value={formik.values.last_name}
                      required />
                    {formik.errors.last_name && formik.touched.last_name ? <Form.Control.Feedback type='invalid'>{formik.errors.last_name}</Form.Control.Feedback> : null}
                  </Form.Group>
                  <Form.Group as={Col} sm={6} controlId='ab-email' className='mb-3'>
                    <Form.Label>{t('Adresse email')} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control type='email'
                      onChange={formik.handleChange('email')}
                      onBlur={formik.handleBlur('email')}
                      isValid={formik.touched.email && !Boolean(formik.errors.email)}
                      isInvalid={formik.touched.email && Boolean(formik.errors.email)}
                      value={formik.values.email}
                      required />
                    {formik.errors.email && formik.touched.email ? <Form.Control.Feedback type='invalid'>{formik.errors.email}</Form.Control.Feedback> : null}
                  </Form.Group>
                  <Form.Group as={Col} sm={6} controlId='ab-phone' className='mb-3'>
                    <Form.Label>{t('Numéro de téléphone')} <span className='text-danger'>*</span></Form.Label>
                    <PhoneInputField formik={formik} />
                  </Form.Group>

                </Row>
              </section>

              <section className='d-sm-flex justify-content-between pt-2'>
                <button type={"submit"} disabled={formik.errors > 0} onClick={() => { console.log(formik.values) }} className='btn btn-lg btn-primary d-block w-100 w-sm-auto mb-2'>{t("Demander mon estimation")}</button>
              </section>
            </form>
          </Col>

          {/* Sidebar (Progress of completion) */}
          <Col lg={{ span: 3, offset: 1 }} className='d-none d-lg-block'>
            <div className='sticky-top pt-5'>
              <h6 className='pt-5 mt-3 mb-2'>{percentageProgress.length * 100 / anchors.length}% {t("de contenu rempli")}</h6>
              <ProgressBar variant='accent' now={percentageProgress.length * 100 / anchors.length} style={{ height: '.25rem' }} className='mb-4' />
              <ul className='list-unstyled'>
                {anchors.map((anchor, indx) => (
                  <li key={indx} className='d-flex align-items-center'>
                    <i className={`fi-check text-${anchor.completed ? 'primary' : 'muted'} me-2`}></i>
                    <ScrollLink to={anchor.to} smooth='easeInOutQuart' duration={600} offset={-95} className='nav-link fw-normal ps-1 p-0'>
                      {t(anchor.label)}
                    </ScrollLink>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </RealEstatePageLayout>
  )
}

export default EstimatePage
